import buttonFactory from 'sdi/components/button';
import { queryK, dispatchK } from 'sdi/shape/functions';

export const { makeIcon, makeLabel, makeLabelAndIcon } = buttonFactory(
    queryK('component/button'),
    dispatchK('component/button'),
);
